<router-outlet></router-outlet>

<!-- <button (click)="toggleLoginState()">Toggle Login State</button> -->